<template>
  <DividerSeparator v-if="failed" class="wide">
    <DecoratedButton
      type="link"
      :route="{ name: pages.AUTH_ACTIVATION_EMAIL }"
      class="wide short dark-blue"
      fontSize=".8em"
    >
      RE-SEND ACTIVATION E-MAIL
    </DecoratedButton>
  </DividerSeparator>
  <DividerSeparator v-else-if="activated">
    <DecoratedButton
      type="link"
      :route="{ name: pages.AUTH_LOGIN }"
      class="wide short dark-blue"
      fontSize=".8em"
    >
      CLICK HERE TO LOG IN
    </DecoratedButton>
  </DividerSeparator>
  <DividerSeparator class="wide" v-else>
    <Loader />
    <div slot="title">Activating Your Bohemia Account</div>
  </DividerSeparator>
</template>

<script>
import Loader from "vue-spinner/src/BounceLoader";

export default {
  name: "auth-activate",
  data: function() {
    return {
      failed: false,
      activated: false,
      loading: false,
      emailSent: false,
      user: {
        email: ""
      }
    };
  },
  components: { Loader },
  created: function() {
    setTimeout(() => {
      this.services.UserResource.activate({
        id: this.$route.params.id
      })
        .then(() => {
          this.activated = true;
        })
        .catch(err => {
          this.failed = true;
        });
    }, 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
